export class Emitter {
    listeners = new Map();
    on(event, listener) {
        let set = this.listeners.get(event);
        if (!set) {
            set = new Set();
            this.listeners.set(event, set);
        }
        set.add(listener);
        return () => this.off(event, listener);
    }
    off(event, listener) {
        this.listeners.get(event)?.delete(listener);
    }
    emit(event, payload) {
        this.listeners.get(event)?.forEach((listener) => {
            try {
                listener(payload);
            }
            catch (err) {
                // A misbehaving host listener must never break the chat.
                console.error('[agentic-chat] listener threw', err);
            }
        });
    }
    clear() {
        this.listeners.clear();
    }
}
